import { render } from "./Cancel.vue?vue&type=template&id=62bdfff6"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Cancel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62bdfff6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62bdfff6', __exports__)) {
    api.reload('62bdfff6', __exports__)
  }
  
  module.hot.accept("./Cancel.vue?vue&type=template&id=62bdfff6", () => {
    api.rerender('62bdfff6', render)
  })

}


export default __exports__